
        import * as module0 from './controllers/audio_controller.js'
        const modules = {
            "./controllers/audio_controller.js": module0,
        };
        export default modules;
      